import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/ubuntu/e_com_frontend/src/app/layouts/default.vue").then(m => m.default || m))
}